import { createFormContext } from '@mantine/form';
export const [PurchaseFormProvider, usePurchaseFormContext, usePurchaseForm] = createFormContext();
